export const axiosLoginTimeout = 30000 // login request timeout is 30sec
export const axiosOtherRequestsTimeout = 3 * 60 * 1000 // others request timeout is 3 minutes
